import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { CART_SIDEBAR } from '@estee/elc-service-view-names';
import serviceNames, { CartService } from '~setup/CartService';
import { serviceBusBaseClass } from '~setup/ServiceBus';

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

CartService.setViews(name, getModuleFederatedName(name), version, [CART_SIDEBAR]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.cartService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: {
        serviceBusBaseClass
    }
});
